// import React, { useEffect, useState } from 'react';
import axios from 'axios';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import styled from 'styled-components';
import Swal from 'sweetalert2';


const AppWrapper = styled.div`
  display: flex;
  height: 100vh;
  font-family: 'Arial', sans-serif;
  touch-action: manipulation;
  overflow: hidden;

  @media (max-width: 1366px) {
    flex-direction: row;
    font-size: 85%;
  }
`;

const LeftPanel = styled.div`
  width: 65%;
  background: linear-gradient(to bottom right,rgb(21, 64, 121),rgb(18, 73, 146));
  color: white;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;

  @media (max-width: 1366px) {
    padding: 1.5rem;
    width: 70%;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;

  @media (max-width: 1366px) {
    margin-bottom: 1rem;
  }
`;

const Logo = styled.img`
  width: 280px;
  max-width: 80%;

  @media (max-width: 1366px) {
    width: 220px;
  }
`;

const RightPanel = styled.div`
  width: 35%;
  background: #f4f4f4;
  padding: 2rem;
  overflow-y: auto;
  font-size: 1.8rem;

  @media (max-width: 1366px) {
    padding: 1.5rem;
    font-size: 1.6rem;
  }
`;

const CountdownCircle = styled.div`
  width: clamp(180px, 20vw, 240px);
  height: clamp(180px, 20vw, 240px);
  border: 12px solid white;
  border-radius: 50%;
  margin: 1.5rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: clamp(3rem, 4vw, 3.6rem);
  font-weight: bold;

  @media (max-width: 1366px) {
    border-width: 10px;
    margin: 1rem auto;
  }
`;

const Event = styled.div`
  padding: 1rem 0;
  border-bottom: 1px solid #ccc;
  font-size: 1.6rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;

  @media (max-width: 1366px) {
    font-size: 1.4rem;
    grid-template-columns: 1fr;
  }

  strong {
    display: block;
    margin-bottom: 0.5rem;
  }

  small {
    font-size: 1.2rem;
    color: #666;
  }
`;

const MeetingInfoWrapper = styled.div`
  text-align: center;
  font-size: 2rem;
  width: 100%;

  @media (max-width: 1366px) {
    font-size: 1.8rem;
  }

  h1 {
    font-size: clamp(3.5rem, 5vw, 5rem);
    margin: 0.5rem 0;
  }

  h2 {
    font-size: clamp(2.5rem, 3.5vw, 3.2rem);
    margin: 0.5rem 0;
    
  }

  h3 {
    font-size: clamp(2rem, 2.5vw, 2.6rem);
    margin: 0.5rem 0;
  }

  p {
    font-size: clamp(1.6rem, 2vw, 2.2rem);
    margin: 0.5rem 0;
  }
`;

const FullScreenButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 2.4rem;
  color: white;
  cursor: pointer;
  z-index: 10;

  &:hover {
    opacity: 0.8;
  }
`;


function CountdownTimer({ endTime }) {
  const calculateSecondsLeft = () => {
    const now = new Date();
    const end = new Date(endTime);
    return Math.max(Math.floor((end - now) / 1000), 0);
  };

  const [secondsLeft, setSecondsLeft] = useState(calculateSecondsLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(calculateSecondsLeft());
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);

  const hours = String(Math.floor(secondsLeft / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((secondsLeft % 3600) / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');

  return <CountdownCircle>{hours}:{minutes}:{seconds}</CountdownCircle>;
}

function RoomEvents() {
    const { resourceEmail,resourceName } = useParams();
    const navigate = useNavigate();
  useWakeLock();
  // const [meetingData, setMeetingData] = useState(null);
  const [meetingData, setMeetingData] = useState({ today: [], tomorrow: [] });
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [nextMeeting, setNextMeeting] = useState(null);
  const [nowTime, setNowTime] = useState(new Date());
  const [isFullscreen, setIsFullscreen] = useState(false);

//   Room Name: The Sandy Phone Booth
// Room Email: c_18832a5lc9cp2htngm3iak4bohkk6@resource.calendar.google.com
// Room buildingId: Dubai-Office
// -----------------------------------------------------------------------------
// Room Name: Meeting Room
// Room Email: c_188f81fml0jh0gremp5sdhg18eg9q@resource.calendar.google.com
// Room buildingId: Dubai-Office
// -----------------------------------------------------------------------------
// Room Name: Conference Room
// Room Email: c_1881f9d705s0ejp2ionudoc9pethq@resource.calendar.google.com
// Room buildingId: Head-Office
// -----------------------------------------------------------------------------
// Room Name: Guest Area
// Room Email: c_18858vtpqug0ehm5m2i0b2j5f64ec@resource.calendar.google.com
// Room buildingId: Dubai-Office
// -----------------------------------------------------------------------------
// Room Name: The Rocky Phone Booth
// Room Email: c_188b63b8jsbf0il2h6b414bbj3v7a@resource.calendar.google.com
// Room buildingId: Dubai-Office
// -----------------------------------------------------------------------------
// Room Name: Al Marwan: RobotPark office
// Room Email: c_188d2bd8704iej4tjbgbvddc4qbh0@resource.calendar.google.com
// Room buildingId: Robotpark-Tower
  const RoomTitle = resourceName;//'Conference Room';
  const meetingRoom = resourceEmail; //'c_1881f9d705s0ejp2ionudoc9pethq@resource.calendar.google.com';
  const appRef = useRef();
  const scriptUrl = 'https://script.google.com/macros/s/AKfycbzOEwqbv8yPRVWXY-Mgv5Yo7SmlFxifFUYvm4PtA_QRyIhW_DvekSxXvUiIxe9VbEOV/exec?action=events&room='+meetingRoom;
  
  

  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      appRef.current.requestFullscreen().then(() => setIsFullscreen(true)).catch(err => {
        console.error(`Error attempting to enable full-screen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false));
    }
  }, []);

  const getMeetings = async () => {

    if (!resourceEmail) navigate('/');;
    await axios
  .get(scriptUrl)
  .then(response => {
    const rawEvents = response.data; // flat array of events

    const today = [];
    const tomorrow = [];

    const now = new Date();
    const todayStr = now.toLocaleDateString('en-CA');
    const tomorrowStr = new Date(now.getTime() + 24 * 60 * 60 * 1000).toLocaleDateString('en-CA');


    rawEvents.forEach(event => {
      const eventDate = event.date;

      const formattedEvent = {
        title: event.title,
        organizer: event.organizer,
        start: event.start,
        end: event.end
      };
      console.log('eventDate:', eventDate, "todayStr:", todayStr);
      if (eventDate === todayStr) {
        today.push(formattedEvent);
      } else if (eventDate === tomorrowStr) {
        tomorrow.push(formattedEvent);
      }
    });

    const meetings = {
      today,
      tomorrow
    };

    setMeetingData(meetings);
  })
  .catch(err => {
    console.error('Error fetching data:', err);
    Swal.fire({
        icon: 'error',
        title: 'Error ',
        text: "Error while fetching data",
      }).then(() => {
        navigate('/'); // Redirect back
      });
  });

  

  }

  useEffect(() => {
    // Initial call
    getMeetings();
  
    // Set interval to call every 1 minute (60000 ms)
    const interval = setInterval(() => {
      getMeetings();
    }, 60000);
  
    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {

      
     const parsedMeetings = meetingData;//JSON.parse(meetingsData);
    console.log('parsedMeetings:', parsedMeetings);


    const todayMeetings = parsedMeetings.today.map((event) => {
      const [startHour, startMin] = event.start.split(':').map(Number);
      const [endHour, endMin] = event.end.split(':').map(Number);
      const now = new Date();
      const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHour, startMin);
      const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHour, endMin);
      return { ...event, startTime, endTime };
    });

    const tomorrowMeetings = parsedMeetings.tomorrow;

    setMeetingData({
      today: todayMeetings,
      tomorrow: tomorrowMeetings
    });

    const interval = setInterval(() => {
      const now = new Date();

      const ongoing = todayMeetings.find(
        (m) => now >= m.startTime && now < m.endTime
      );

      const upcoming = todayMeetings.find(
        (m) => now < m.startTime
      );

      setCurrentMeeting(ongoing || null);
      setNextMeeting(ongoing ? null : upcoming || null);
      setNowTime(now);
    }, 1000);

    return () => clearInterval(interval);
  }, [nowTime]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  if (!meetingData) {
    return <div style={{ fontSize: 36, textAlign: 'center', marginTop: '40%' }}>Loading...</div>;
  }

  const { today, tomorrow } = meetingData;

  const formattedNow = nowTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  const isOngoing = (start, end) => {
    const now = new Date();
    return new Date(start) <= now && now <= new Date(end);
  };
  
  return (
    <AppWrapper ref={appRef}>
      <FullScreenButton onClick={toggleFullScreen}>
        {isFullscreen ? <span style={{color: "black",padding: "3px",fontWeight: 700}}>X</span> : '⛶'}
      </FullScreenButton>

      <LeftPanel>
        <LogoWrapper>
          <Logo   style={{     filter: 'invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)' }} src="https://almarwangroup.com/images/logo.svg" alt="Logo" />
        </LogoWrapper>

        <MeetingInfoWrapper>
          {currentMeeting ? (
            <>
              <h3>
                {new Date(currentMeeting.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} -&nbsp; 
                {new Date(currentMeeting.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </h3>
              <h1 style={{letterSpacing: "3px"}}>BOOKED</h1>
              <CountdownTimer endTime={currentMeeting.endTime} />
              <h2>{currentMeeting.title}</h2>
              <p>
                Organizer: <strong>{currentMeeting.organizer}</strong>
              </p>
            </>
          ) : nextMeeting ? (
            <>
              <h1>Next Meeting In</h1>
              <CountdownTimer endTime={nextMeeting.startTime} />
              <h2>{nextMeeting.title}</h2>
              <p>
                Organizer: <strong>{nextMeeting.organizer}</strong>
              </p>
            </>
          ) : (
            <>
              <h1>No Meeting</h1>
              <p>Current Time: {formattedNow}</p>
            </>
          )}
          <hr style={{ margin: '1rem 0',border: '1px solid #ccc' }} />
            <div style={{ marginTop: '1rem' }}>              
              <small> {RoomTitle}</small>
            </div>
        </MeetingInfoWrapper>
      </LeftPanel>

      <RightPanel>
        <h2>Today</h2>
        {today.map((event, i) => (
          <Event key={i}
          style={{
            backgroundColor: isOngoing(event.start, event.end) ? '#d1fae5' : 'transparent', // Light green
            borderLeft: isOngoing(event.start, event.end) ? '4px solid #10b981' : 'none',  // Green left border
            color: isOngoing(event.start, event.end) ? '#fff' : '#333',  // Green left border
            padding: '10px',
            borderRadius: '8px',
            marginBottom: '10px'
          }}
          >
            <div>
              <strong>{event.start} - {event.end}</strong>
            </div>
            <div>
              {event.title}<br/>
              <small>Organizer: {event.organizer}</small>
            </div>
          </Event>
        ))}

        <h2 style={{ marginTop: '2rem' }}>Tomorrow</h2>
        {tomorrow.map((event, i) => (
          <Event key={i}>
            <div>
              <strong>{event.start} - {event.end}</strong>
            </div>
            <div>
              {event.title}<br/>
              <small>Organizer: {event.organizer}</small>
            </div>
            
          </Event>
        ))}
      </RightPanel>
    </AppWrapper>
  );
}

export default RoomEvents;


function useWakeLock() {
  const wakeLockRef = useRef(null);

  useEffect(() => {
    const requestWakeLock = async () => {
      try {
        if ('wakeLock' in navigator) {
          wakeLockRef.current = await navigator.wakeLock.request('screen');
          console.log('Wake lock is active');

          // Re-acquire the wake lock if it is released (e.g., when user switches tabs)
          wakeLockRef.current.addEventListener('release', () => {
            console.log('Wake lock released');
          });
        }
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    };

    requestWakeLock();

    // Re-apply wake lock on visibility change
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        requestWakeLock();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      wakeLockRef.current?.release();
    };
  }, []);
}